import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "flex flex-col gap-3 justify-center items-center w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "test-base font-bold text-blue-500" }, "Loading...", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingIcon = _resolveComponent("LoadingIcon")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.id,
    class: "col-span-12 my-10"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_LoadingIcon, {
        icon: "puff",
        class: "w-8 h-8",
        color: "#2196f3"
      }),
      _hoisted_3
    ])
  ], 8, _hoisted_1))
}